import { toCamelCase } from '__core/shared/util/transform';
import template from './householdExpenses.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    household: '<',
    contacts: '<',
    income: '<',
    assets: '<',
    homeLoanSecurities: '<',
    workflow: '<',
    owner: '<',
    idTicket: '<',
    index: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      $mdUtil,
      eventService,
      helperService,
      householdsService,
      incomeService,
      HouseholdGroup,
      HouseholdCategory,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableExpensesDescriptions = [];
      ctrl.expenseEstimate = [];
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().cca2;
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: true
        });
        ctrl.availableExpensesDescriptions = householdsService.getAvailableExpenseDescriptions();
        ctrl.household = ctrl.household || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.income = ctrl.income || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.owner = ctrl.owner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.idItem = ctrl.idTicket || ctrl.contacts[0]?.id || '';
        ctrl.index = ctrl.index === 0 ? 0 : ctrl.index || -1;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.householdGroupExpenses = [
          {
            name: HouseholdGroup.food.name,
            title: HouseholdGroup.food.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) => _.flatten(HouseholdGroup.food.types).indexOf(h?.type?.name) > -1
            )
          },
          {
            name: HouseholdGroup.discretionary.name,
            title: HouseholdGroup.discretionary.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) => _.flatten(HouseholdGroup.discretionary.types).indexOf(h?.type?.name) > -1
            )
          },
          {
            name: HouseholdGroup.children_and_education.name,
            title: HouseholdGroup.children_and_education.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) =>
                _.flatten(HouseholdGroup.children_and_education.types).indexOf(h?.type?.name) >
                -1
            )
          },
          {
            name: HouseholdGroup.health_and_wellness.name,
            title: HouseholdGroup.health_and_wellness.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) =>
                _.flatten(HouseholdGroup.health_and_wellness.types).indexOf(h?.type?.name) > -1
            )
          },
          {
            name: HouseholdGroup.transport.name,
            title: HouseholdGroup.transport.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) => _.flatten(HouseholdGroup.transport.types).indexOf(h?.type?.name) > -1
            )
          },
          {
            name: HouseholdGroup.property.name,
            title: HouseholdGroup.property.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) => _.flatten(HouseholdGroup.property.types).indexOf(h?.type?.name) > -1
            )
          },
          {
            name: HouseholdGroup.other_commitments.name,
            title: HouseholdGroup.other_commitments.title.toLowerCase(),
            group: _.filter(
              ctrl.household?.householdExpenses,
              (h) =>
                _.flatten(HouseholdGroup.other_commitments.types).indexOf(h?.type?.name) > -1
            )
          }
        ];
        if (ctrl.household?.householdExpenses?.length) {
          ctrl.getExpensesEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.getCurrentLabel = ({ householdExpense }) =>
        ctrl.organizationCountry === 'NZ'
          ? householdExpense?.type?.titleNZ
          : householdExpense?.type?.title;

      ctrl.getCurrentDescription = ({ type }) => {
        const desc = _.find(ctrl.availableExpensesDescriptions, (d) => d?.type === type);
        return ctrl.organizationCountry === 'NZ'
          ? desc?.descriptionNZ || '-'
          : desc?.description || '-';
      };

      ctrl.isIncludedInHem = ({ householdExpense }) =>
        HouseholdCategory.hem.types.indexOf(householdExpense?.type?.name) > -1;

      ctrl.getExpensesEstimate = () => {
        ctrl.isProcessing = true;
        financesService
          .getExpenses({ id: ctrl.idItem, type: ctrl.idTicket ? 'ticket' : 'contact' })
          .then((res) => {
            if (res?.status) {
              ctrl.expenseEstimate = res?.expenses || [];
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.totalExpensesByHousehold = ({ path, isGroup }) => {
        const totalExpenses = _.find(ctrl.expenseEstimate, (e) => e?.id === ctrl.household?.id);
        if (totalExpenses) {
          if (isGroup) {
            return totalExpenses[toCamelCase(path)] || 0;
          }
          return totalExpenses[path] || 0;
        }
        return 0;
      };

      ctrl.totalMonthlyExpenseByField = ({ field }) =>
        _.multiply(field?.value, helperService.getFrequencyValue(field?.frequency, true));

      ctrl.getContact = ({ idContact }) => _.find(ctrl.contacts, (c) => c?.id === idContact);

      ctrl.saveHousehold = _.debounce(() => {
        const data = {
          household: ctrl.household,
          idx: ctrl.index
        };
        ctrl.onFinished({ data });
      }, 3000);

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'expenses') {
          ctrl.getExpensesEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
